import { getDuplicates, hasDuplicates } from './duplicates';
import { merge } from './merge';

export * from './merge';

export const arrayUtils = {
  merge,
  hasDuplicates,
  getDuplicates,
};
